module.exports = __webpack_public_path__ + "img/ikeaLab2.ff2a3bc5.png";